<template>
  <PreviewSheet radius="0" class="pb-6">
    <div>
      <div
        class="email-header flex-column align-start justify-center px-4 py-3"
      >
        <PreviewLogo
          class="email-header__logo flex-column align-center w-full justify-center"
          disable-palette
          logo-size="xs"
        />
      </div>
    </div>
  </PreviewSheet>
</template>

<script>
import PreviewLogo from '@/lib/builder/public/preview/PreviewLogo.vue'
import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'

export default {
  name: 'EmailHeader',
  components: { PreviewLogo, PreviewSheet },
}
</script>

<style lang="scss" scoped>
.email-header__logo {
  max-height: 40px;
}
</style>
